<template>
  <div
    ref="rootElement"
    class="chat-background"
    :class="{
      [`chat-background--${themeColor}`]: themeColor,
      'chat-background--pattern': showThemePattern,
    }"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
import type { ChatSettingsColor } from '@/data/models/domain/chats/ChatSettings'
import { useTemplateRef } from '@/composition/vue/compositionApi'

defineProps<{
  themeColor?: ChatSettingsColor
  showThemePattern?: boolean
}>()

const rootElement = useTemplateRef('rootElement')

const getRootElementOrNull = () => {
  return rootElement.value
}

defineExpose({
  getRootElementOrNull,
})
</script>

<style scoped lang="scss">
.chat-background {
  position: relative;

  &--purple {
    background: linear-gradient(230.94deg, rgba(159, 99, 235, 0.4) 0%, rgba(46, 161, 255, 0.4) 100%);
  }

  &--blue {
    background: linear-gradient(0deg, #a5cff1, #a5cff1);
  }

  &--azure {
    background: linear-gradient(90deg, #ccf2f5 20.78%, #9fb4fc 100%);
  }

  &--turquoise {
    background: linear-gradient(90deg, #bfebaa 0%, #7c95ea 100%);
  }

  &--green {
    background: linear-gradient(90deg, #d2de8f 0%, #93d8af 100%);
  }

  &--yellow {
    background: linear-gradient(270deg, #fccfb7 0%, #f5f193 68.08%);
  }

  &--red {
    background: linear-gradient(90deg, #ffddb5 0%, #c5bcff 100%);
  }

  &--gray {
    background: #ebebeb;
  }

  &--white {
    background: linear-gradient(233.56deg, #cbdae5 14.58%, #e3eaef 64.59%);
  }

  &--pattern::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background-image: url('@/assets/images/chat-pattern.png');
    opacity: 0.05;
  }
}
</style>
